import React, { useEffect, useState } from "react"
import { useTable } from "react-table"
import "./style/style.css"
import { Box } from "theme-ui"
import { IDeviceList } from "types/IDeviceList"
import ReactPaginate from "react-paginate"
import { restructureArray } from "utils"
import { SkeletonLoader } from "components"
import { useTranslation } from "react-i18next"

export interface AllFacilitiestableProps {
 columns: any[]
 data: IDeviceList[] | any[]
 fullHeight: boolean
 paginate: boolean
 isLoading?: boolean
 scrollVisible?: boolean
}

export const MyTableComponent: React.FC<AllFacilitiestableProps> = ({
 columns,
 data,
 fullHeight,
 paginate,
 isLoading,
 scrollVisible,
}) => {
 const { t } = useTranslation("translation")
 const [restructuredData, setRestructuredData] = useState<any[]>([])
 const [currentPage, setCurrentPage] = useState<number>(0)
 const [rowsPerPage, setRowsPerPage] = useState<any>(3)

 const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
  columns,
  data: restructuredData.length ? restructuredData[currentPage] : [],
 })

 useEffect(() => {
  const restructuredArray = restructureArray([...data], rowsPerPage)
  setRestructuredData(restructuredArray)
 }, [data])

 const paginationHandler = (value: any) => {
  setCurrentPage(value.selected)
 }

 const heightStyle = fullHeight ? "h-content" : "max-h-[48vh]"

 return (
  <>
   {isLoading ? (
    <SkeletonLoader count={8} />
   ) : (
    <>
     <Box
      bg="highlight"
      color="text-black"
      className={`${
       scrollVisible ? "" : "overflow-x-auto overflow-y-auto"
      } mx-auto hide-scroll-icon  ${heightStyle}`}
     >
      <Box bg="highlight" className="my-table-container min-w-[100%]">
       {data?.length ? (
        <table {...getTableProps()} className="my-table w-full">
         <thead className="whitespace-nowrap">
          {headerGroups.map((headerGroup, index) => (
           <tr {...headerGroup.getHeaderGroupProps()} key={index}>
            {headerGroup.headers.map((column, index) => (
             <th {...column.getHeaderProps()} key={index} className="my-table-header">
              {column.render("Header")}
             </th>
            ))}
           </tr>
          ))}
         </thead>
         <tbody {...getTableBodyProps()} className="relative">
          {rows.map((row, index) => {
           prepareRow(row)
           return (
            <tr
             className="my-table-row border-y-[1px] border-light-gray text-center w-full"
             {...row.getRowProps()}
             key={index}
            >
             {row.cells.map((cell, index) => (
              <td
               {...cell.getCellProps()}
               key={index}
               className={`border-light-gray border-r-[1.5px] Jakarta-font text-base font-medium py-4 px-2 whitespace-nowrap min-w-[35px] align-top`}
              >
               {cell.render("Cell")}
              </td>
             ))}
            </tr>
           )
          })}
         </tbody>
        </table>
       ) : (
        <div className="text-center py-20">{t("noDataFound")}</div>
       )}
      </Box>
     </Box>
     {data?.length ? (
      paginate && (
       <Box bg="highlight" color="text-black" className="absolute bottom-0 right-0 left-0 w-full">
        <div className="flex justify-between items-center py-6 w-full px-2">
         <div className="flex w-[30%] items-center">
          <div className="w-full flex gap-1 items-center">
           <p className="font-medium lg:text-base text-xs lg:w-[50%] text-[10px] Jakarta-font">
            {t("rowsPerPage")}:
           </p>
           <input
            className="border-[1.5px] rounded border-light-gray flex justify-center items-center outline-none py-1 pl-2 lg:pl-2 w-full lg:w-[20%] bg-transparent"
            type="number"
            min="1"
            onChange={(event) => {
             setRowsPerPage(event.target.value)
             setCurrentPage(0)

             const restructuredArray = restructureArray([...data], Number(event.target.value))
             setRestructuredData(restructuredArray)
            }}
            defaultValue={rowsPerPage}
           />
          </div>
         </div>
         <div className="pagination-container w-[70%]">
          <ReactPaginate
           previousLabel={"Previous"}
           disabledClassName={"disableButton"}
           nextLabel={t("next")}
           breakLabel={"..."}
           breakClassName={"break-me"}
           pageCount={restructuredData?.length}
           marginPagesDisplayed={0}
           pageRangeDisplayed={1}
           onPageChange={paginationHandler}
           containerClassName={"pagination"}
           activeClassName={"active"}
           previousClassName={currentPage === 0 ? "common" : " previous"}
           nextClassName={currentPage === restructuredData?.length - 1 ? "common" : " next"}
          />
         </div>
        </div>
       </Box>
      )
     ) : (
      <></>
     )}
    </>
   )}
  </>
 )
}
